import ISO_3166_1_ALPHA_2_CODES from "@payair/e-com-common-sdk/isoCodes/iso3166Alpha2Codes"
import { isIso3166Alpha2 } from "@payair/e-com-common-sdk/core/Validators"
import { CountryOption } from "./CountryOption.model"

export const getCountryOptions = (displayLanguage: string, allowedCountries?: string[]): CountryOption[] => {
  const countryCodes =
    allowedCountries && allowedCountries.length > 0
      ? allowedCountries.filter(countryCode => isIso3166Alpha2(countryCode))
      : ISO_3166_1_ALPHA_2_CODES
  const displayNames = new Intl.DisplayNames([displayLanguage], { type: "region" })

  return countryCodes
    .map(code => ({
      code,
      name: displayNames.of(code) || code,
    }))
    .sort((left, right) => left.name.localeCompare(right.name, displayLanguage))
}
